import type {
  HotelBookingRoomOption,
  TRoom,
} from "@/features/hotels/types/types";

export function isRefundable(roomOffer: HotelBookingRoomOption): boolean {
  return !roomOffer.tags.includes("Non-refundable");
}

export function getTotalVisitors(rooms: TRoom[]): number {
  return rooms.reduce(
    (sum, room) => sum + (room.adults ?? 1) + (room.children ?? 0),
    0,
  );
}
